class General {
    constructor(pkg, config) {
        this.pkg = pkg;
        this.config = config;
    }

    // Guard contra ws en estado CONNECTING (post-#299 con permessage-deflate,
    // el handshake es ~50-100ms más lento por la negociación de extensión).
    // Si el user clickea panels que disparan send() ANTES de que el handshake
    // termine, salta "InvalidStateError: Failed to execute 'send' ... Still in
    // CONNECTING state". Defensive: si no está OPEN, no-op silencioso. El
    // polling del panel (cada 5s) recupera al primer tick post-handshake.
    _wsReady = () => {
        const ws = this.config.ws;
        return ws && ws.readyState === WebSocket.OPEN;
    };

    sendDialog = msg => {
        msg = msg.trim();
        if (msg && this._wsReady()) {
            const msgsplit = msg.split(" ");

            if (msgsplit[0].charAt(0) == "/") {
                msgsplit[0] = msgsplit[0].toLowerCase();
            }
            if (msg.length > this.config.textMaxLength) {
                msg = msg.slice(0, this.config.textMaxLength);
            }

            this.pkg.setPackageID(this.pkg.serverPacketID.dialog);
            this.pkg.writeString(msg);
            this.config.ws.send(this.pkg.dataSend());
        }
    };

    // Ticket #321: el cliente confirma el destino elegido del modal
    // del marinero. Server valida sesión + oro + teleporta.
    sendUseFerry = idxRuta => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(this.pkg.serverPacketID.useFerry);
        this.pkg.writeByte(idxRuta);
        this.config.ws.send(this.pkg.dataSend());
    };

    // Pide la lista global de chars PvE conectados (panel GLOBAL del
    // BOX 5). Sin payload. El server responde con globalList.
    sendRequestGlobalList = () => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(this.pkg.serverPacketID.requestGlobalList);
        this.config.ws.send(this.pkg.dataSend());
    };

    // Click del buff icon de Sombra Oscura de Morgolock → server desactiva
    // el modo y broadcast el estado al viewport. Sin payload.
    sendDeactivateSombraOscura = () => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(
            this.pkg.serverPacketID.requestDeactivateSombraOscura
        );
        this.config.ws.send(this.pkg.dataSend());
    };

    // Click del buff icon de El Ojo del Demiurgo. Mismo patrón que sombra.
    sendDeactivateOjoDemiurgo = () => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(
            this.pkg.serverPacketID.requestDeactivateOjoDemiurgo
        );
        this.config.ws.send(this.pkg.dataSend());
    };

    // Click del buff icon de Sigilo de Atidorfa.
    sendDeactivateSigiloAtidorfa = () => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(
            this.pkg.serverPacketID.requestDeactivateSigiloAtidorfa
        );
        this.config.ws.send(this.pkg.dataSend());
    };

    // Confirma pago de amnistía del modal /PERDON.
    sendConfirmPerdon = () => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(this.pkg.serverPacketID.confirmPerdon);
        this.config.ws.send(this.pkg.dataSend());
    };

    // Confirma compra del upgrade premium Magia (Morgolock).
    sendConfirmMagiaUpgrade = () => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(this.pkg.serverPacketID.confirmMagiaUpgrade);
        this.config.ws.send(this.pkg.dataSend());
    };

    // La Guarida del Bardo — cliente reporta que el video actual terminó.
    // Payload: string videoId (server usa para dedup — solo el primer
    // reporte válido dispara advance de cola).
    sendRadioTrackEnded = (videoId) => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(this.pkg.serverPacketID.radioTrackEnded);
        this.pkg.writeString(videoId || "");
        this.config.ws.send(this.pkg.dataSend());
    };

    // Confirma el modal /criminal (#328) — el user aceptó volverse Criminal.
    sendConfirmCriminal = () => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(this.pkg.serverPacketID.confirmCriminal);
        this.config.ws.send(this.pkg.dataSend());
    };

    // Generic end-buff — click sobre cualquier buff icon clickeable
    // (Invisibilidad, Fuerza, Celeridad). Server hace clearXxx según
    // el buffType. Mantener en sync con END_BUFF_HANDLERS del server
    // protocol.js.
    sendEndBuff = (buffType) => {
        if (!this._wsReady()) return;
        this.pkg.setPackageID(this.pkg.serverPacketID.requestEndBuff);
        this.pkg.writeByte(buffType);
        this.config.ws.send(this.pkg.dataSend());
    };
}

// Tipos de buff que pueden cancelarse anticipadamente vía sendEndBuff.
// Sincronizado con END_BUFF_HANDLERS del server (protocol.js).
export const BUFF_TYPE = {
    INVISIBILIDAD: 1,
    FUERZA: 2,
    CELERIDAD: 3
};

export default General;
